<a class="app-tooltip-icon" nz-popover [nzPopoverPlacement]="popoverPlacement" [nzPopoverContent]="popoverContentTemplate" [dir]="direction">
  <app-image [name]="icon" [inlineSvg]="iconInlineSvg"></app-image>
</a>

<ng-template #popoverContentTemplate>
  <div class="app-tooltip-icon-content" [params]="popoverContentParams" translate>{{popoverContent}}</div>
</ng-template>
